module.exports = __webpack_public_path__ + "static/media/grogol.31f4e9ab.jpg";